import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PageHero, Section, fadeUp } from "../components/sections";
import LeadMagnetSection from "../components/LeadMagnetSection";
import SeoHead from "../components/SeoHead";
import { apiClient } from "../lib/site";

export default function InsightsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient
      .get("/blog/posts")
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="insights-page">
      <SeoHead
        title="Insights"
        description="Practitioner perspective from Elite Solutions Hub: AI in FinTech, FHIR interoperability, composable commerce, real-time logistics, edtech engagement, and SaaS engineering disciplines."
        path="/insights"
      />
      <PageHero
        overline="Insights"
        title={<>Field notes from the platforms we ship.</>}
        intro="Practitioner perspective on FinTech, Healthcare, E-commerce, Logistics, Education, SaaS and Government—written by the engineers and strategists who actually built it."
        testId="insights-hero"
      />

      <Section className="bg-[#050505]">
        {loading && <p className="text-zinc-500 text-sm">Loading…</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#27272A]">
          {posts.map((p, i) => (
            <motion.article
              key={p.slug}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: i * 0.04 }}
              className="bg-[#050505]"
              data-testid={`insight-card-${p.slug}`}
            >
              <Link to={`/insights/${p.slug}`} className="block group hover:bg-[#0A0A0C] transition-colors h-full">
                <div className="aspect-[3/2] overflow-hidden bg-[#0A0A0C]">
                  <img
                    src={p.cover_image}
                    alt=""
                    className="w-full h-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-8">
                  <p className="overline mb-4" style={{ color: "#71717A" }}>
                    {p.category} · {p.read_time}
                  </p>
                  <h3 className="font-serif-display text-2xl text-white font-light leading-snug group-hover:text-zinc-200 transition">
                    {p.title}
                  </h3>
                  <p className="mt-4 text-zinc-500 text-sm leading-relaxed">{p.excerpt}</p>
                  <p className="mt-8 text-zinc-600 text-xs">{p.date} · {p.author}</p>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </Section>

      <LeadMagnetSection />
    </div>
  );
}
